import axios from 'axios';
const STORE_URL = 'https://happyboxstore.com';
const ADDON_PRODUCT_TYPE = 'Gift';
const COLLECTION_HANDLE = 'build-a-happy-box';
const actions = {
    async getProducts(context) {
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
        .then(response => response.data)
        .then((data) => {
          // Figure out how many pages of data we have to pull
          const numOfPages = Math.ceil(data.collection.products_count / 250);
          fetchProducts(numOfPages, []);
        })
        .catch((err) => {
          console.log('***Error Fetching NumOfProducts***');
        });
    
        function fetchProducts(pageNum, productList) {
          // Recursive function that gets the full list of products
          if (pageNum != 0) {
            axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${pageNum}`)
              .then(response => response.data)
              .then((data) => {
                const updatedProductList = [...data.products, ...productList];
                fetchProducts(pageNum - 1, updatedProductList);
              })
              .catch((err) => {
                console.log('***Error Fetching Products***');
              });
          } else {
            sortFetchedProducts(productList);
          }
        }
    
        function sortFetchedProducts(totalProductList) {
          axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
          .then(response => response.data)
          .then((data) => {
            totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
    
            var addonProductList = totalProductList.filter((product) => {
              if (product.product_type == ADDON_PRODUCT_TYPE && (product.variants.some(x => x.inventory_quantity > 0) || product.variants.some(x => x.inventory_policy == "continue"))) {
                product.tags = product.tags.split(', ');
                var isBrandable = product.tags.filter(y => y.includes("Brandable Swag"));
                let designable = product.tags.filter(y => y.includes("Designable"));
                if(isBrandable && isBrandable.length > 0 && (product.variants.length > 1 || (designable && designable.length > 0))){
                    product.variants = product.variants.filter(x => parseFloat(x.price) > 0).map((variant) =>{
                        variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
                        variant.available = variant.inventory_quantity > 0;
                        variant.sku = variant.sku ? variant.sku : "";
                        variant.featured_image = product.images.find(x => x.id == variant.image_id)
                        return variant
                    })
            
                    return product;
                }

                return false
              }
            });

            context.commit('setAddonProducts', addonProductList);
            //Get Categories
            getOccasions(addonProductList);
          })
          .catch((err) => {
            console.log(err);
            console.log('***Error Fetching NumOfProducts***');
          });
        }
        function getOccasions(addonProductList){
          var tags = [...new Set(addonProductList.flatMap(x => x.tags.filter(y => y.includes("Swag_") )))];
          if(tags.length > 0){
            tags = tags.map((x) =>{
              const currentArray = x.replace("Swag_","").split("_");
              if (currentArray.length > 1){
                var currentObject = { category: currentArray[0], title: currentArray[1], tag: x };
                return currentObject;
              }
            })
            var sortedFilters = [];
            sortedFilters = [...tags.reduce((hash, {category,title,tag}) => {
              const current = hash.get(category) || { category, filters: [] };
              current.filters.push({ title, tag });
              return hash.set(category, current);
            }, new Map).values()];

            let categories = sortedFilters.find(x => x.category == "Category");
            categories.filters.sort((a,b) => {
              if (a.title == "Sale"){
                return 1
              }
              else if(b.title == "Sale"){
                return -1
              }
              else{
                let aValue = a.title == "Snacks & Treats" ? 4 : (a.title == "Brandable Swag" ? 3 : (a.title == "Tea/Coffee" ? 2 : (a.title == "Candles" ? 1 : 0)));
                let bValue = b.title == "Snacks & Treats" ? 4 : (b.title == "Brandable Swag" ? 3 : (b.title == "Tea/Coffee" ? 2 : (b.title == "Candles" ? 1 : 0)));
                return bValue - aValue;
              }
            });
            categories.filters.unshift({title: "View All", tag: "Swag_Category_View All"});
            context.commit('setCategories', categories);
          }
        }
    },
};

export default actions;
